var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMediumLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 8,
    viewBox: "0 0 181 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.80465 3.64645C0.609388 3.84171 0.609388 4.15829 0.80465 4.35355L3.98663 7.53553C4.18189 7.7308 4.49847 7.7308 4.69374 7.53553C4.889 7.34027 4.889 7.02369 4.69374 6.82843L1.86531 4L4.69374 1.17157C4.889 0.976311 4.889 0.659728 4.69374 0.464466C4.49847 0.269204 4.18189 0.269204 3.98663 0.464466L0.80465 3.64645ZM1.1582 4.5H180.158V3.5H1.1582V4.5Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMediumLeft);
export default __webpack_public_path__ + "static/media/ArrowMediumLeft.96cca582ccb10b06fcd845423b671434.svg";
export { ForwardRef as ReactComponent };